module.exports = __webpack_public_path__ + "60f605aff4d17f2d135ab7903b35e484.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/browser_chrome.png
// module id = 367
// module chunks = 1